var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 20,
    viewBox: "0 0 43 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0242 1.48047C19.8452 9.34815 13.2888 1.48047 13.2888 1.48047C13.2888 1.48047 14.6001 6.06995 13.6166 9.02033C12.6332 11.9707 4.7655 14.2654 1.4873 15.5767C15.2557 20.8218 35.0342 18.5271 42.137 15.5767C39.5144 13.6098 29.6798 12.2985 29.0242 9.02033C28.3685 5.74213 28.6964 3.55666 29.0242 1.48047Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontNeck);
export default __webpack_public_path__ + "static/media/FrontNeck.b4ee66c7c4b89dfc54679cc778f89232.svg";
export { ForwardRef as ReactComponent };